import { UnitType } from '../units';
import { UnitSystem } from './unit-system';

export const UnitSymbol = {
  HOURS: 'h',
  KG: 'kg',
  KMH: 'km/h',
  LBS: 'lbs',
  METERS: 'm',
  MILES: 'mi',
  MINUTES: 'min',
  MPH: 'mph',
  PERCENTAGE: '%',
  SECONDS: 's',
} as const;

export type UnitSymbol = (typeof UnitSymbol)[keyof typeof UnitSymbol];

export function getUnitSymbol(unitType: UnitType, unitSystem: UnitSystem): UnitSymbol | null {
  switch (unitType) {
    case UnitType.LENGTH:
      return getLengthUnitSymbol(unitSystem);
    case UnitType.WEIGHT:
      return getWeightUnitSymbol(unitSystem);
    case UnitType.SPEED:
      return getSpeedUnitSymbol(unitSystem);
    default:
      return null;
  }
}

export function getLengthUnitSymbol(unitSystem: UnitSystem): UnitSymbol {
  return unitSystem === UnitSystem.METRIC ? UnitSymbol.METERS : UnitSymbol.MILES;
}

export function getSpeedUnitSymbol(unitSystem: UnitSystem): UnitSymbol {
  return unitSystem === UnitSystem.METRIC ? UnitSymbol.KMH : UnitSymbol.MPH;
}

export function getWeightUnitSymbol(unitSystem: UnitSystem): UnitSymbol {
  return unitSystem === UnitSystem.METRIC ? UnitSymbol.KG : UnitSymbol.LBS;
}
